import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import SpeakerService from '../../services/speakerService';

const initialState = {
  Speakers: [],
  SpeakerId: {},
  pageSize: 20,
  currentPage: 1,
  totalElements: 0,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

export const createSpeaker = createAsyncThunk(
  'Speaker/create',
  async (data, thunkAPI) => {
    try {
      return await SpeakerService.createSpeaker(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllSpeaker = createAsyncThunk(
  'Speaker/getAll',
  async (_, thunkAPI) => {
    try {
      return await SpeakerService.getAll();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSpeakerById = createAsyncThunk(
  'Speaker/id',
  async (id, thunkAPI) => {
    try {
      return await SpeakerService.getById(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateSpeaker = createAsyncThunk(
  'Speaker/update',
  async ({ id, data }, thunkAPI) => {
    try {
      return await SpeakerService.updateSpeaker({ id, ...data });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteSpeaker = createAsyncThunk(
  'Speaker/delete',
  async (id, thunkAPI) => {
    try {
      return await SpeakerService.deleteSpeaker(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const SpeakerSlice = createSlice({
  name: 'speakers',
  initialState,
  reducers: {
    clearSpeaker: state => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(createSpeaker.pending, state => {
        state.isLoading = true;
      })
      .addCase(createSpeaker.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const created = action.payload?.result || action.payload?.data || action.payload;
        if (created) {
          state.Speakers.unshift(created);
        }
      })
      .addCase(createSpeaker.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllSpeaker.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAllSpeaker.fulfilled, (state, action) => {
        state.isLoading = false;
        const payload = action.payload?.result || action.payload?.data || action.payload;
        const items = Array.isArray(payload) ? payload : payload?.items || payload?.data || [];
        state.Speakers = items;
        const pagination = action.payload?.pagination || {};
        state.currentPage = pagination.current_page || 1;
        state.pageSize = pagination.limit || items.length || 20;
        state.totalElements = pagination.total_items || items.length || 0;
      })
      .addCase(getAllSpeaker.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getSpeakerById.pending, state => {
        state.isLoading = true;
      })
      .addCase(getSpeakerById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.SpeakerId = action.payload?.result || action.payload?.data || action.payload;
      })
      .addCase(getSpeakerById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateSpeaker.pending, state => {
        state.isLoading = true;
      })
      .addCase(updateSpeaker.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(updateSpeaker.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteSpeaker.pending, state => {
        state.isLoading = true;
      })
      .addCase(deleteSpeaker.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const deletedId = action.payload?.data ?? action.payload?.id;
        state.Speakers = state.Speakers.filter(goal => goal.id !== deletedId);
      })
      .addCase(deleteSpeaker.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { clearSpeaker } = SpeakerSlice.actions;
export default SpeakerSlice.reducer;
